import { AxiosResponse, CancelToken } from "axios";
import http from "../../../shared/http";
import { AvailabilityRequestDto, AvailabilityResponseDto } from "./dtos";

export const availability = async (
  data: AvailabilityRequestDto,
  cancelToken: CancelToken
): Promise<AxiosResponse<AvailabilityResponseDto>> => {
  return await http.post<AvailabilityResponseDto>(
    `/availability`,
    {
      ...data,
      _method: "GET",
    },
    { cancelToken }
  );
};
